import React from 'react';
import classNames from 'classnames';

import Warning from 'components/Warning';
import {ErrorField} from 'components/Fields';
import ImageSelect from 'components/ImageSelect';

const ImageSelectField = ({
  input: {onBlur, onChange, value},
  options,
  className,
  meta: {touched, error, warning},
  disabled,
  placeholder,
  Description
}: any) => {
  return (
    <div className="SelectField">
      <ImageSelect
        value={value}
        options={options}
        disabled={disabled}
        placeholder={placeholder}
        className={classNames({error: touched && error}, className)}
        onChange={onChange}
        onBlur={onBlur}
        Description={Description}
      />
      <ErrorField touched={touched} error={error} />
      {warning && <Warning>{warning}</Warning>}
    </div>
  );
};

export default ImageSelectField;
